import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import Select from 'react-select';

import { limpiarProducto, obtenerProducto } from '../../../actions/inventario';

import { formatNumber } from '../../../utils/generalFunctions';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const DetallesProducto = ({ producto, reestablecerProducto }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.inventario);

    const [detallesModal, setDetallesModal] = useState(false);

    const [inventario, setInventario] = useState([]);

    const [unidadData, setUnidadData] = useState(null);
    const [unidadesFilter, setUnidadesFilter] = useState([]);

    const columns = [
        {
            name: 'Área',
            selector: row => row?.area?.nombre || 'Sin definir'
        },
        {
            name: 'Organizador',
            selector: row => row?.organizador?.nombre || 'Sin definir'
        },
        {
            name: 'Ubicación',
            selector: row => row?.ubicacion?.nombre || 'Sin definir'
        },
        {
            name: 'Cantidad',
            selector: row => formatNumber(row?.cantidad * parseFloat(unidadData?.cantidad || 1), 2, '', '')
        }
    ];

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Detalles de producto */
    const handleAbrir = () => {
        dispatch(limpiarProducto());
    }

    const handleSelectUnidad = (option) => {
        setUnidadData(option);
    }

    const handleCerrar = () => {
        setUnidadData(null);
        setUnidadesFilter([]);
        setDetallesModal(false);
        reestablecerProducto(null);
    }

    useEffect(() => {
        if(producto){
            setDetallesModal(true);

            setUnidadesFilter(producto?.unidades);

            for (var i = 0; i < producto?.unidades?.length; i++) {
                if(!unidadData){
                    if(producto?.unidades[i]?.cantidad == 1) {
                        setUnidadData(producto?.unidades[i]);
                    }
                }
            }

            dispatch(obtenerProducto(producto?.id));
        }        
    }, [producto]);

    useEffect(() => {
        if(detalles){
            setInventario(detalles);
        }
    }, [detalles]);

    return (
        <Modal show={detallesModal} size="xl" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Cantidades existentes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="unidad"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Unidad"
                                options={unidadesFilter}
                                value={unidadData}
                                onChange={(value) => handleSelectUnidad(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>
                </div>

                <DataTable 
                    columns={columns}
                    data={inventario}
                    highlightOnHover={true}
                />
            </Modal.Body>
        </Modal>
    )
}

export default DetallesProducto;